import React from "react";
import styled, { css } from "styled-components";

const SIZE_STYLES = {
  sm: css`
    padding: 8px 14px;
    font-size: 13px;
  `,
  md: css`
    padding: 12px 16px;
    font-size: 14px;
  `,
  lg: css`
    padding: 18px 20px;
    font-size: 15px;
  `,
};

const VARIANT_STYLES = {
  primary: css`
    color: ${({ theme }) => theme.primaryButton.color};
    background: ${({ theme }) => theme.primaryButton.background};
    border-color: ${({ theme }) => theme.primaryButton.borderColor};
  `,
  remove: css`
    color: ${({ theme }) => theme.menu.deleteColor};
    background: ${({ theme }) => theme.primaryButton.removeBackground};
    border-color: ${({ theme }) => theme.menu.deleteColor};
  `,
};

const Button = ({
  text,
  iconLeft,
  iconRight,
  leftIconStyle,
  rightIconStyle,
  children,
  variant = "primary",
  size = "md",
  fullWidth = false,
  borderRadius,
  ...props
}) => {
  return (
    <ButtonContainer
      $variant={variant}
      $size={size}
      $fullWidth={fullWidth}
      $borderRadius={borderRadius}
      {...props}
    >
      {iconLeft && <IconWrapper style={leftIconStyle}>{iconLeft}</IconWrapper>}
      {text ? text : children}
      {iconRight && <IconWrapper style={rightIconStyle}>{iconRight}</IconWrapper>}
    </ButtonContainer>
  );
};

export default Button;

const ButtonContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: ${({ $borderRadius }) => $borderRadius || "4px"};
  border: 1px solid transparent;
  font-weight: 500;
  line-height: 100%;
  letter-spacing: 0.04px;
  cursor: pointer;
  width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "auto")};

  ${({ $size }) => SIZE_STYLES[$size] || SIZE_STYLES.md}
  ${({ $variant }) => VARIANT_STYLES[$variant] || VARIANT_STYLES.primary}

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.primaryButton.borderColor};
    outline-offset: 2px;
  }
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
`;
